exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ActiveFilters__item {\n    all: initial;\n    font-family: var(--font-family);\n}\n  .DS__ActiveFilters__item .DS__ActiveFilters__item:last-child {\n    margin-right: 0;\n  }\n  .DS__ActiveFilters__item {\n\n  display: flex;\n  margin-right: 12px;\n}\n\n.DS__ActiveFilters__item:last-child {\n  margin-right: 0;\n}\n", ""]);

// exports
exports.locals = {
	"item": "DS__ActiveFilters__item"
};